module.exports = __webpack_public_path__ + "img/39-0KC.472e692.jpg";